import React, { useState, useEffect, useCallback } from 'react';
import './ModalMessage.css';

const ModalMessage = () => {
  const [message, setMessage] = useState('');
  const [type, setType] = useState('info'); // 'success', 'error', 'info', 'confirm'
  const [isVisible, setIsVisible] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  const [resolvePromise, setResolvePromise] = useState(null); // Para o modo 'confirm'

  const hideMessage = useCallback(() => {
    setIsVisible(false);
    setMessage('');
    setType('info');
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }
    // Se estiver no modo confirm e não tiver resolvido, resolve como false (cancelado)
    if (resolvePromise) {
      resolvePromise(false);
      setResolvePromise(null);
    }
  }, [timeoutId, resolvePromise]);

  // Função para exibir mensagens (modo alert)
  const showMessage = useCallback((msg, msgType = 'info', duration = 3000) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    setMessage(msg);
    setType(msgType);
    setIsVisible(true);
    setResolvePromise(null); // Garante que não está em modo confirm

    const newTimeoutId = setTimeout(() => {
      hideMessage();
    }, duration);
    setTimeoutId(newTimeoutId);
  }, [timeoutId, hideMessage]);

  // Função para exibir confirmação (modo confirm)
  const showConfirm = useCallback((msg) => {
    return new Promise((resolve) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      setMessage(msg);
      setType('confirm');
      setIsVisible(true);
      setResolvePromise(() => resolve); // Armazena a função resolve da Promise
      setTimeoutId(null); // Não tem timeout no modo confirm
    });
  }, [timeoutId]);

  // Lógica para o botão OK/Confirmar
  const handleConfirm = (result) => {
    if (resolvePromise) {
      resolvePromise(result);
    }
    hideMessage();
  };

  // Expõe as funções globalmente
  useEffect(() => {
    window.globalAlert = showMessage;
    window.globalConfirm = showConfirm;

    return () => {
      delete window.globalAlert;
      delete window.globalConfirm;
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [showMessage, showConfirm, timeoutId]);

  if (!isVisible) {
    return null;
  }

  const isConfirm = type === 'confirm';
  const title = isConfirm ? 'Confirmação' :
                type === 'success' ? 'Sucesso' :
                type === 'error' ? 'Erro' :
                'Informação';

  return (
    <div className={`modal-message-overlay ${isVisible ? 'visible' : ''}`} onClick={() => isConfirm ? null : hideMessage()}>
      <div className={`modal-message-content ${type}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-message-header">
          <span className="modal-message-title">{title}</span>
          {!isConfirm && <button className="modal-message-close" onClick={() => handleConfirm(false)}>&times;</button>}
        </div>
        <div className="modal-message-body">
          <p>{message}</p>
        </div>
        <div className="modal-message-footer">
          {isConfirm ? (
            <>
              <button className="modal-message-button cancel" onClick={() => handleConfirm(false)}>Cancelar</button>
              <button className="modal-message-button confirm" onClick={() => handleConfirm(true)}>Confirmar</button>
            </>
          ) : (
            <button className="modal-message-button" onClick={() => handleConfirm(false)}>OK</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalMessage;
